export default {
    binEditor: {
        dstBanner: {
            spring: 'Počinje ljetno računanje vremena. Ovaj dan ima 92 intervala (sat se pomiče naprijed 02:00 → 03:00).',
            autumn: 'Završava ljetno računanje vremena. Ovaj dan ima 100 intervala (sat se pomiče natrag 03:00 → 02:00).',
        },
        dayPosition: 'Dan {current} od {total}',
        binsLabel: 'Intervali',
        binCount: {
            spring: '{count} (DST pomak naprijed)',
            autumn: '{count} (DST pomak natrag)',
            normal: '{count} (normalno)',
        },
        daySum: 'Zbroj dana',
        dirty: 'nespremljeno',
        copyDay: 'Kopiraj ovaj dan na druge dane...',
        resetDay: 'Poništi dan',
    },
}
